// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}

.file-upload {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 0 13px;
  border-radius: 7px;
  background: var(--primary-color);
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.file-upload:hover:not(.disabled) {
  background: var(--primary-color-hover);
}
.file-upload.disabled {
  cursor: default;
  opacity: 0.55;
}

input {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  opacity: 0;
}

.material-symbols-outlined {
  font-size: 17px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EAAQ,qBAAA;AAER;;AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGF;AADE;EAAyB,sCAAA;AAI3B;AAHE;EAAa,eAAA;EAAiB,aAAA;AAOhC;;AAJA;EAAQ,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,UAAA;AAW/D;;AAVA;EAA6B,eAAA;AAc7B","sourcesContent":[":host { display: inline-block; }\n\n.file-upload {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 36px;\n  padding: 0 13px;\n  border-radius: 7px;\n  background: var(--primary-color);\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n\n  &:hover:not(.disabled) { background: var(--primary-color-hover); }\n  &.disabled { cursor: default; opacity: .55; }\n}\n\ninput { position: absolute; inline-size: 1px; block-size: 1px; opacity: 0; }\n.material-symbols-outlined { font-size: 17px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
